import React, { useEffect, useState } from "react";
import About from "../../components/about/About";
import Blog from "../../components/blog/Blog";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import Ingredients from "../../components/ingredient/Ingredients";
import SlideShow from "../../components/slideshow/SlideShow";
import Banner from "../../components/banner/Banner";

const Main = () => {
  const [showBanner, setSowBanner] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setSowBanner(true);
    }, 30000)
  }, [])
  return (
    <div>
      <Header />
      <SlideShow />
      {/* <Zoom> */}
      <About />
      {/* </Zoom> */}
      <Ingredients />
      <Blog />
      <Footer />
      <Banner show={showBanner} handleClose={() => setSowBanner(false)} />
    </div>
  );
};

export default Main;
